import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown'
import { Box, Button, Menu, MenuItem, Stack } from '@mui/material'
import { useState } from 'react'
import { Header } from 'src/components/header/Header'
import { HeaderTitle } from 'src/components/header/HeaderTitle'
import { useDownloadGlossaryCsv } from './api/useDownloadGlossaryCsv'
import { useGlossaryJobPolling } from './api/useGlossaryJobPolling'
import { useQueryGlossaryJobs } from './api/useQueryGlossaryJobs'
import { CsvUploadDrawer } from './components/CsvUploadDrawer'
import { GlossaryDescription } from './components/GlossaryDescription'
import { GlossaryJobStatusDrawer } from './components/GlossaryJobStatusDrawer'
import { GlossaryTable } from './components/GlossaryTable'
export const GlossaryListPage = () => {
  const { data, isPending } = useQueryGlossaryJobs()
  const glossaryJobs = data?.glossaryJobs ?? []

  // 一覧APIはcompletedのジョブのみ返すため、先頭が適用中
  const latestCompletedJob = glossaryJobs[0] ?? null

  const { downloadGlossaryCsv, isDownloading } = useDownloadGlossaryCsv()
  useGlossaryJobPolling()
  const [uploadDrawerOpen, setUploadDrawerOpen] = useState(false)
  const [statusDrawerOpen, setStatusDrawerOpen] = useState(false)
  const [menuAnchorEl, setMenuAnchorEl] = useState<HTMLElement | null>(null)

  const handleDownloadLatest = () => {
    if (latestCompletedJob !== null) {
      downloadGlossaryCsv(latestCompletedJob.id, latestCompletedJob.fileName)
    }
  }

  return (
    <Stack
      height="calc(100vh - var(--banner-height, 0px))"
      bgcolor="background.grayLight"
    >
      <Header>
        <HeaderTitle title="翻訳用語集設定" />
      </Header>
      <Box
        sx={{
          flex: 1,
          overflow: 'hidden',
          display: 'flex',
          flexDirection: 'column',
          gap: 2,
          pt: 2,
        }}
      >
        <Box sx={{ px: 3 }}>
          <GlossaryDescription />
        </Box>
        <Box
          sx={{
            px: 3,
            display: 'flex',
            justifyContent: 'flex-end',
            alignItems: 'center',
            gap: 2,
          }}
        >
          <Button
            variant="contained"
            endIcon={<ArrowDropDownIcon />}
            onClick={e => setMenuAnchorEl(e.currentTarget)}
            aria-haspopup="true"
            aria-expanded={menuAnchorEl ? 'true' : undefined}
          >
            用語集をアップロード(CSV)
          </Button>
          <Menu
            anchorEl={menuAnchorEl}
            open={Boolean(menuAnchorEl)}
            onClose={() => setMenuAnchorEl(null)}
            anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
            transformOrigin={{ vertical: 'top', horizontal: 'right' }}
            slotProps={{
              paper: {
                sx: {
                  width: menuAnchorEl?.offsetWidth,
                },
              },
            }}
          >
            <MenuItem
              onClick={() => {
                setMenuAnchorEl(null)
                setUploadDrawerOpen(true)
              }}
            >
              CSVをアップロード
            </MenuItem>
            <MenuItem
              onClick={() => {
                setMenuAnchorEl(null)
                setStatusDrawerOpen(true)
              }}
            >
              データ処理状況の確認
            </MenuItem>
          </Menu>
        </Box>
        <GlossaryTable
          data={glossaryJobs}
          isLoading={isPending}
          onDownloadCsv={downloadGlossaryCsv}
          isDownloading={isDownloading}
          activeJobId={latestCompletedJob?.id ?? null}
        />
      </Box>
      <CsvUploadDrawer
        open={uploadDrawerOpen}
        onClose={() => setUploadDrawerOpen(false)}
        onOpenStatusDrawer={() => setStatusDrawerOpen(true)}
        onDownloadRegistered={handleDownloadLatest}
        isDownloadingRegistered={isDownloading}
        isDownloadRegisteredDisabled={latestCompletedJob === null}
      />
      <GlossaryJobStatusDrawer
        open={statusDrawerOpen}
        onClose={() => setStatusDrawerOpen(false)}
      />
    </Stack>
  )
}
